import { useState } from 'react'
import getFieldRenderObject from '../../../utils/newforms/render/getFieldRenderObject'
import StatusMessage, {
  useStatusMessage,
} from '../../../ui/StatusMessage/StatusMessage'
import FormRender from '../../../utils/newforms/render/FormRender'
import Button from '../../../ui/Button/Button'
import { createForm } from '../../../utils/newforms/createForm'
import isFormValid from '../../../utils/newforms/validation/isFormValid'
import getFormValues from '../../../utils/newforms/getFormValues'
import PopUp from '../../../ui/PopUp/PopUp'
import './ApiContactForm.sass'
import sendTgMessage from './sendTgMessage'
import regAnalyticReq from '../regAnalyticReq'
import { withRouter } from 'react-router-dom'

function ApiContactForm({ onClose, tourName = '', ...router }) {
  const tourId = router.match.params.id

  return (
    <PopUp
      show
      close={onClose}
      title={'Ваш первый шаг в Арктику'}
      className="ContactUsPopUp"
    >
      <ContactForm tourName={tourName} tourId={tourId} />
    </PopUp>
  )
}

function ContactForm({ tourName = '', tourId }) {
  const [form, setForm] = useState(
    createForm({ formPattern: new ContactFormPattern() }),
  )
  const [showErrors, setShowErrors] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [statusMessage, setStatusMessage] = useStatusMessage()

  const onSubmit = (e) => {
    e.preventDefault()
    if (!isFormValid({ form })) {
      setStatusMessage({
        show: true,
        type: 'fail',
        message: 'Пожалуйста, заполните все поля формы',
        closeAfter: 5000,
      })
      return setShowErrors(true)
    }
    setShowErrors(false)
    setIsLoading(true)

    const values = getFormValues({ form })

    sendTgMessage({
      telegramChatId: '1791133258',
      // telegramChatId: '781663101',
      threadId: 'Обращение из модуля бронирования',
      msg: `
Обратная связь из модуля бронирования (hotel.iterrainc.ru)
Тур: ${tourName}

Имя: ${values.name}
E-mail: ${values.email}
Номер телефона: ${values.phone.value}
${values.tgid ? `Telegram: ${values.tgid}` : ``}
${values.whatid ? `Whatsapp: ${values.whatid}` : ``}
Комментарий: ${values.comment}
      `,
    }).then((result) => {
      if (result.data.ok) {
        setStatusMessage({
          show: true,
          type: 'success',
          message:
            'Спасибо за обращение. Наш менеджер ответит в ближайшее время!',
          closeAfter: 5000,
        })
        regAnalyticReq({
          projectId: 'bXy8m4F5kHXNU3ADr43Z',
          counterType: 'targets',
          eventType: `formSend`,
          offerId: tourId,
          offerType: 'tour',
          offerLink: `https://hotel.iterrainc.ru/tours/${tourId}`,
        })
          .then((r) => {
            console.log('🚀 ~ TourPage contact clicked~ r:', r)
          })
          .catch((e) => {
            console.log('🚀 ~ TourPage contact clicked ~ e:', e)
          })

        setForm(createForm({ formPattern: new ContactFormPattern() }))
        return setIsLoading(false)
      }
    })
  }

  return (
    <div className="ContactUs-Form ApiContactForm">
      <h5>Title</h5>
      {/* <p>description</p> */}
      <form onSubmit={onSubmit}>
        <div className="Form-Fields">
          {statusMessage.show && (
            <StatusMessage
              className="Site-StatusMessage"
              type={statusMessage.type}
              message={statusMessage.message}
            />
          )}
          <FormRender
            form={form}
            setForm={setForm}
            sections={[
              {
                fields: ['name', 'email', 'phone', 'tgid', 'whatid', 'comment'],
              },
            ]}
            errors={showErrors}
          />
        </div>
        <div className="ContactUsForm-Buttons">
          <Button
            title={'Отправить'}
            theme="solid"
            fill="black"
            iconWeight="solid"
            size={48}
            onClick={onSubmit}
            isLoading={isLoading}
          />
        </div>
      </form>
    </div>
  )
}

class ContactFormPattern {
  constructor() {
    this.name = {
      field: {
        fieldId: 'name',
        fieldType: 'input',
        inputType: 'text',
        label: 'Ваше имя',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.email = {
      field: {
        fieldId: 'email',
        fieldType: 'input',
        inputType: 'email',
        validationPattern: 'email',
        label: 'E-mail',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.phone = {
      field: {
        fieldId: 'phone',
        fieldType: 'phone',
        inputType: 'text',
        label: 'Контактный телефон',
        required: true,
      },
      render: getFieldRenderObject(),
    }
    this.tgid = {
      field: {
        fieldId: 'tgid',
        fieldType: 'input',
        inputType: 'text',
        label: '@Telegram',
        required: false,
      },
      render: getFieldRenderObject(),
    }
    this.whatid = {
      field: {
        fieldId: 'whatid',
        fieldType: 'input',
        inputType: 'text',
        label: '@Whatsapp',
        required: false,
      },
      render: getFieldRenderObject(),
    }
    this.comment = {
      field: {
        fieldId: 'comment',
        fieldType: 'textarea',
        label: 'Комментарий',
        required: false,
      },
      render: getFieldRenderObject(),
    }
  }
}

export default withRouter(ApiContactForm)
